module.exports = {"itinerary":"Itinerary Arrangement","start_date":"Start Date","end_date":"End Date","airline":"Airline","aircompany_code":"Airline Conf number","flight_number":"Flight Number","time":"Flight Date","airport":"Airport"}


//////////////////
// WEBPACK FOOTER
// ./src/lang/en/components/airticket/create/itinerary.json
// module id = db6m
// module chunks = 58